<template>
  <div class="wrap">
    <div class="wrapContent">

      <router-link tag="a" to="/index" v-show="user.user_id == undefined">{{pc_lang.Login}}</router-link>

      <span class="el-dropdown-link" v-show="user.user_id != undefined" @click="$router.push({name: 'UserInfo'})">
        {{pc_lang.Hi}}, {{signTel}}
      </span>

      <a v-show="user.user_id != undefined" @click="signOut">{{pc_lang.Logout}}</a>

      <router-link tag="a" to="/user/safety">{{pc_lang.Security_center}}</router-link>

      <a>{{pc_lang.Customer_Service}}</a>

      <el-dropdown :show-timeout="0">
        <span class="el-dropdown-link">
          选择语言<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="changeLang('cn')">中文</el-dropdown-item>
          <el-dropdown-item @click.native="changeLang('en')">English</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>

    </div>
  </div>
</template>

<script>
import * as API_INDEX from '@/api/index'
import { mapGetters } from 'vuex'

export default {
  name: 'ShortCut',
  components: {

  },
  computed: {
    ...mapGetters(['user']),
    /* 手机加密 */
    signTel() {
      let tel = this.user.mobile
      return !!!tel ? '' : tel.replace(/^(\d{3})\d*(\d{3})$/,'$1****$2')
    }
  },
  created(){
    this.getSite()
  },
  async mounted() {

  },
  methods: {
    /* 退出登录 */
    signOut() {
      this.$store.dispatch('token', {})
      this.$store.dispatch('user', {})
      if (this.$route.name != 'Index') {
        this.$router.push({name: 'Index'})
      }
    },
    // 选择语言
    async changeLang(lang) {
      await this.$store.dispatch('langCountry', lang)
      both.storage.set('langCountry', lang)
    },
    getSite() {
      API_INDEX.webSite().then(res=> {
        this.$store.dispatch('site', res.data)
      }, rej=> {`网站配置获取失败`})
    }
  }
}
</script>
<style lang="scss" scoped>
.wrap{
  background: $shortCut;
  height: 30px;
  color: #fff;
  .wrapContent{
    display: flex;
    height: 100%;
    align-items: center;
    justify-content: flex-end;
    font-size: 12px;
    >a{
      margin-left: 24px;
    }
  }
}

.el-dropdown-link {
  cursor: pointer;
  color: #fff;
  font-size: 12px;
  margin-left: 24px;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.el-dropdown-menu__item{
  padding: 0 6px;
}
</style>